import { apiDelete, apiGet, apiPost, CRM_API_URI } from "./index";

const clientContact = {
  getAll: async (clientId: number) => {
    const data = await apiGet(`${CRM_API_URI}/api/contact/getall?clientId=${clientId}`);
    return data;
  },
  updateIsActive: async (clientId: number, contactId: number, isActive: boolean) => {
    const data = await apiPost(`${CRM_API_URI}/api/contact/active?clientId=${clientId}&contactId=${contactId}&isActive=${isActive}`);
    return data;
  },
  delete: async (clientId: number, contactId: number) => {
    const Updated = await apiDelete(`${CRM_API_URI}/api/contact/remove?clientId=${clientId}&contactId=${contactId}`);
    return Updated;
  },
};

export default clientContact;
